import React from 'react'
import Icon from './Icon'

const GoTriangleRight = props => (
  <Icon viewBox="0 0 40 40" {...props}>
    <g>
      <path d="m12.5 5l15 15-15 15v-30z" />
    </g>
  </Icon>
)

export default GoTriangleRight



// WEBPACK FOOTER //
// ./icons/TriangleRight.js